// Angular
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
// Services
import { SystemApiService } from '@cv-invision/core';
// Models
import { CLASS_VALUATION_PROVIDER } from '../model/global-configuration.constant';
// Others
import { Observable } from 'rxjs';

@Injectable({providedIn: 'root'})
export class OrganizationsService {
	constructor(
		private httpClient: HttpClient,
		private systemApiService: SystemApiService
	) {
	}

	/**
	 * Return the list of organizations by name
	 * @param name
	 * @returns
	 */
	getOrganizationsByName = (name: string = '', limit: number = 50): Observable<any> => {
		let httpParams: any = new HttpParams();
		if (name && name !== '') {
			httpParams = httpParams.append('Name', name);
		}

		if (limit) {
			httpParams = httpParams.append('limit', limit);
		}

		return Observable.create(observer => {
			this.httpClient.get(this.systemApiService.api.identitySystemService + `${CLASS_VALUATION_PROVIDER}/organizations`, {params: httpParams})
				.subscribe(
					(result: any) => {
						let organizations = [];
						if (result.data) {
							organizations = result.data.map(o => {
								return {
									id: o.id,
									name: o.name
								};
							});
						}

						observer.next(organizations);
						observer.complete();
					},
					error => console.error(error)
				);
		});
	}
}
